import React, { useEffect, useState } from "react";
import MainLayout from "Layouts/Main";
import ProgressStep from "Components/ProgressStep";
import Investigation from "Components/Investigation";
import AssetDetails from "Components/AssetDetails";
import SecondaryDetails from "Components/SecondaryDetails";
import BearingDetails from "Components/BearingDetails";
import Recommendation from "Components/Recommendation";
import assets from "../../../../Assets";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.scss";
import { useDispatch } from "react-redux";
import {
  addAssetDetails,
  addBearingDetails,
  addInvestigation,
  addRecommendation,
  editAssetDetails,
  editBearingDetails,
  editInvestigation,
  editRecommendation,
  editSecondayDetail,
  addSecondaryDetail,
  fetchSingleFailureAnalysisRequest
} from "../../../../Redux/Slices/failureAnalysisReqSlice";
import Appendix from "Components/Appendix";
import { toast } from "react-toastify";

const SendReportFar = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [recommendFile, setRecommendFile] = useState(null);
  const [dataExists, setDataExists] = useState(false);
  const [investigationValue, setInvestigationValue] = useState([]);
  const [assetValue, setAssetValue] = useState([]);
  const [secondaryValue, setSecondaryValue] = useState([]);
  const [bearingValue, setBearingValue] = useState([]);
  const [recommendationValue, setRecommendationValue] = useState([]);
  const [bearingLength, setBearingLength] = useState(0);

  const dispatch = useDispatch();
  const location = useLocation();

  const { remote_failure_details_id = null } = location.state || {};

  const handleInvestigationDataChange = (data) => {
    console.log("data", data);
    setInvestigationValue(data);
  };

  const handleAssetDataChange = (data) => {
    console.log("data", data);
    setAssetValue(data);
  };

  const handleSecondaryValue = (data) => {
    console.log("data", data);
    setSecondaryValue(data);
  };

  const handleBearingDataChange = (data) => {
    console.log("dataForBearing", data);
    setBearingValue(data);
  };

  const handleRecommendationDataChange = (data) => {
    console.log("dataForBearing", data);
    setRecommendationValue(data);
  };

  const steps = [
    { title: "Component Parts" },
    { title: "Primary Details" },
    { title: "Secondary Details" },
    { title: "Bearing Details" },
    { title: "Recommendation" },
    { title: "Appendix" },
  ];

  // Function to render the component based on the current step
  const renderStepContent = () => {
    switch (currentStep) {
      case 0:
        return (
          <Investigation
            id={remote_failure_details_id}
            onDataChange={handleInvestigationDataChange}
            setExist={setDataExists}
            bearingLength={bearingLength}
          />
        );
      case 1:
        return (
          <AssetDetails
            id={remote_failure_details_id}
            onDataChange={handleAssetDataChange}
            setExist={setDataExists}
            bearingLength={bearingLength}
          />
        );
      case 2:
        return (
          <SecondaryDetails
            id={remote_failure_details_id}
            onDataChange={handleSecondaryValue}
            setExist={setDataExists}
            bearingLength={bearingLength}
          />
        );
      case 3:
        return (
          <BearingDetails
            id={remote_failure_details_id}
            onDataChange={handleBearingDataChange}
            setExist={setDataExists}
            bearingLength={bearingLength}
          />
        );
      case 4:
        return (
          <Recommendation
            id={remote_failure_details_id}
            onDataChange={handleRecommendationDataChange}
            setExist={setDataExists}
          />
        );
      case 5:
        return (
          <Appendix
            selectedFile={recommendFile}
            setSelectedFile={setRecommendFile}
          />
        );
      default:
        return null;
    }
  };

  const renderApi = (data) => {
    switch (currentStep) {
      case 0:
        handleInvestigation(investigationValue, dataExists);
        break;
      case 1:
        handleAssetDetails(assetValue, dataExists);
        break;
      case 2:
        handleSecondaryDetails(secondaryValue, dataExists);
        break;
      case 3:
        handleBearingDetails(bearingValue, dataExists);
        break;
      case 4:
        handleRecommendation(recommendationValue, dataExists);
        break;
      case 5:
        handleRoutePreview(remote_failure_details_id)
        break;
      default:
        return null;
    }
  };

  useEffect(() => {
    getIndividualData();
  }, []);

  const getIndividualData = () => {
    dispatch(
      fetchSingleFailureAnalysisRequest({
        data: {
          remote_failure_details_id: remote_failure_details_id || null,
        },
        callBack: getAssetDetailsData,
      })
    );
  };

  const getAssetDetailsData = (data) => {
    setBearingLength(data?.result?.remote_failure_asset_details
      ?.remote_failure_bearing_info_details?.remote_failure_bearing_details?.length)
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    renderApi();
  };

  const handlePreviousStep = () => {
    if (currentStep === 0) {
      // Cancel
      navigate("/request/failureAnalysisRequest");
    } else {
      //Previous
      setCurrentStep(currentStep - 1);
    }
  };

  const handleInvestigation = (investigationValue, dataExists) => {
    console.log("investigationValue", investigationValue);

    if (!investigationValue || investigationValue.length === 0) {
      toast.info("Please fill in at least one component part detail.");
      return;
    }

    if (dataExists) {
      console.log("exists");
      const dataForUpdate = investigationValue?.map((item) => ({
        remote_failure_details_id: remote_failure_details_id,
        bearingcomponentlistid: item?.primaryValue?.value,
        bearingcomponentlistname: item?.primaryValue?.label,
        bearingName: item?.bearingName,
        bearingNumber: item?.bearingOption?.value,
        //removing the null values container and uploading the rest using filter
        upload: item?.imgAndObservationContainers
          .filter((img) => img?.image || img?.observation)
          .map((img) => ({
            image: img?.image,
            observation: img?.observation,
          })),
        obser: item?.observations
          .filter((obser) => obser?.obs)
          .map((obser) => ({
            obs: obser?.obs,
          })),
      }));
      const updatePayload = {
        remote_failure_details_id: remote_failure_details_id,
        bearingDetails: dataForUpdate,
      };

      console.log(updatePayload);
      dispatch(
        editInvestigation({
          data: updatePayload,
          callBack: () => {
            setDataExists(false);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    } else {
      // setCurrentStep(currentStep + 
      const addPayload = {
        bearingDetails: investigationValue.map((item) => ({
          remote_failure_details_id: remote_failure_details_id,
          bearingcomponentlistid: item?.primaryValue?.value,
          bearingcomponentlistname: item?.primaryValue?.label,
          bearingName: item?.bearingName,
          bearingNumber: item?.bearingOption?.value,
          upload: item?.imgAndObservationContainers
            .filter((img) => img?.image || img?.observation)
            .map((img) => ({
              image: img?.image,
              observation: img?.observation,
            })),
          obser: item?.observations
            .filter((obser) => obser?.obs)
            .map((obser) => ({
              obs: obser?.obs,
            })),
        })),
      };
      console.log(addPayload, "addPayload");

      dispatch(
        addInvestigation({
          data: addPayload,
          callBack: (data) => {
            // setFarInvestigationId(data?.data?.far_investigation_id);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    }
  };
  const handleAssetDetails = (assetDetails) => {
    console.log("assetDetails", assetDetails);
    if (dataExists) {
      console.log("exists");
      const dataForUpdate = assetDetails?.map((item) => ({
        remote_failure_details_id: remote_failure_details_id,
        primarymodeoffailureid: item?.primaryValue?.value,
        primarymodeoffailurename: item?.primaryValue?.label,
        bearingName: item?.bearingName,
        bearingNumber: item?.bearingOption?.value,
        upload: item?.imgAndObservationContainers
          .filter((img) => img?.selectedImage || img?.imgObservation)
          .map((img) => ({
            image: img?.selectedImage,
            causeOfFailure: img?.imgObservation,
          })),
        descr: item?.observations
          .filter((obser) => obser?.obs)
          .map((obser) => ({
            desc: obser?.obs,
          })),
      }));
      const updatePayload = {
        remote_failure_details_id: remote_failure_details_id,
        failureDetails: dataForUpdate,
      };

      console.log(updatePayload);
      dispatch(
        editAssetDetails({
          data: updatePayload,
          callBack: () => {
            setDataExists(false);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    } else {
      // setCurrentStep(currentStep + 1)
      const addPayload = {
        failureDetails: assetDetails.map((item) => ({
          remote_failure_details_id: remote_failure_details_id,
          primarymodeoffailureid: item?.primaryValue?.value,
          primarymodeoffailurename: item?.primaryValue?.label,
          bearingName: item?.bearingName,
          bearingNumber: item?.bearingOption?.value,
          upload: item?.imgAndObservationContainers
            .filter((img) => img?.selectedImage || img?.imgObservation)
            .map((img) => ({
              image: img?.selectedImage,
              causeOfFailure: img?.imgObservation,
            })),
          descr: item?.observations
            .filter((obser) => obser?.obs)
            .map((obser) => ({
              desc: obser?.obs,
            })),
        })),
      };
      console.log(addPayload, "addPayloadAsset");
      setCurrentStep(currentStep + 1);

      dispatch(
        addAssetDetails({
          data: addPayload,
          callBack: (data) => {
            // setFarInvestigationId(data?.data?.far_investigation_id);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    }
  };

  const handleSecondaryDetails = (secondaryDetails) => {
    console.log("secondaryDetails", secondaryDetails);
    if (dataExists) {
      console.log("exists");
      const dataForUpdate = secondaryDetails?.map((item) => ({
        remote_failure_details_id: remote_failure_details_id,
        secondarymodeoffailureid: item?.secondaryValue?.value,
        secondarymodeoffailurename: item?.secondaryValue?.label,
        bearingName: item?.bearingName,
        bearingNumber: item?.bearingOption?.value,
        upload: item?.imgAndObservationContainers
          .filter((img) => img?.selectedImage || img?.imgObservation)
          .map((img) => ({
            image: img?.selectedImage,
            causeOfFailure: img?.imgObservation,
          })),
        descr: item?.observations
          .filter((obser) => obser?.obs)
          .map((obser) => ({
            desc: obser?.obs,
          })),
      }));
      const updatePayload = {
        remote_failure_details_id: remote_failure_details_id,
        failureDetails: dataForUpdate,
      };

      console.log(updatePayload);
      setCurrentStep(currentStep + 1);
      dispatch(
        editSecondayDetail({
          data: updatePayload,
          callBack: () => {
            setDataExists(false);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    } else {
      // setCurrentStep(currentStep + 1)
      const addPayload = {
        failureDetails: secondaryDetails.map((item) => ({
          remote_failure_details_id: remote_failure_details_id,
          secondarymodeoffailureid: item?.secondaryValue?.value,
          secondarymodeoffailurename: item?.secondaryValue?.label,
          bearingName: item?.bearingName,
          bearingNumber: item?.bearingOption?.value,
          upload: item?.imgAndObservationContainers
            .filter((img) => img?.selectedImage || img?.imgObservation)
            .map((img) => ({
              image: img?.selectedImage,
              causeOfFailure: img?.imgObservation,
            })),
          descr: item?.observations
            .filter((obser) => obser?.obs)
            .map((obser) => ({
              desc: obser?.obs,
            })),
        })),
      };
      console.log(addPayload, "addPayloadSecondary");
      setCurrentStep(currentStep + 1);

      dispatch(
        addSecondaryDetail({
          data: addPayload,
          callBack: (data) => {
            // setFarInvestigationId(data?.data?.far_investigation_id);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    }
  };

  const handleBearingDetails = (bearingDetails, dataExists) => {
    console.log("bearingDetails", bearingDetails);
    console.log("dataExistsbbb", dataExists);

    const mappedData = bearingDetails?.map((item) => ({
      remote_failure_details_id: remote_failure_details_id,
      bearing_name: item?.bearingName || "",
      bearing_number: item?.bearingOption?.value || null,
      images_and_description: item?.imgAndObservationContainers
        ?.filter((img) => img?.selectedImage || img?.imgObservation)
        ?.map((img) => ({
          image: img?.selectedImage || null,
          description: img?.imgObservation || "",
        })) || [],
      analysis: item?.observations
        ?.filter((obser) => obser?.obs)
        ?.map((obser) => ({
          text: obser?.obs || "",
        })) || [],
    })) || [];

    const payload = {
      remote_failure_details_id: remote_failure_details_id,
      data: mappedData,
    };

    console.log("saving bearing details", payload);
    dispatch(
      editBearingDetails({
        data: payload,
        callBack: () => {
          setDataExists(false);
          setCurrentStep(currentStep + 1);
        },
      })
    );
  };

  const handleRecommendation = (recommendationValue, dataExists) => {
    const item = recommendationValue && recommendationValue.length > 0 ? recommendationValue[0] : null;

    if (!item) {
      setCurrentStep(currentStep + 1);
      return;
    }

    const payload = {
      remote_failure_details_id: remote_failure_details_id,
      conclusion: item?.conclusion,
      conclusion_images: item?.conclusionImages
        ?.filter(img => img.selectedImage || img.imgObservation)
        ?.map(img => ({
          image: img.selectedImage,
          description: img.imgObservation
        })) || [],
      recommendation: item?.recommendation,
      recommendation_images: item?.recommendationImages
        ?.filter(img => img.selectedImage || img.imgObservation)
        ?.map(img => ({
          image: img.selectedImage,
          description: img.imgObservation
        })) || []
    };

    if (dataExists) {
      console.log("exists");
      console.log(payload);
      dispatch(
        editRecommendation({
          data: payload,
          callBack: () => {
            setDataExists(false);
            setCurrentStep(currentStep + 1);
          },
        })
      );
    } else {
      console.log(payload, "addPayloadRecommendation");
      dispatch(
        addRecommendation({
          data: payload,
          callBack: () => {
            setCurrentStep(currentStep + 1);
          },
        })
      );
    }
  };

  const handleRoutePreview = (id) => {
    navigate("/request/failureAnalysisRequest/previewReport", {
      state: {
        remote_failure_details_id: id,
      },
    });
  };

  return (
    <MainLayout pageName={"Failure Analysis Requests"}>
      <div
        className="goBackDiv"
        onClick={() => navigate(`/request/failureAnalysisRequestDetails/${remote_failure_details_id}`)}
      >
        <img src={assets.Icons.backArrow} alt="backIcon" />
        <div className="ms-3">Back to Failure Analysis Request Details</div>
      </div>

      <ProgressStep steps={steps} currentStep={currentStep} />
      <form>
        <div className="stepContentWrapper mt-5">
          {renderStepContent()}
          <div className="farFormButtonContainer">
            <button
              type="button"
              onClick={handlePreviousStep}
              className="cancelButton"
            >
              {currentStep === 0 ? "Cancel" : "Previous"}
            </button>
            <button
              type="submit"
              onClick={handleNextStep}
              className="nextButton"
              style={{ marginLeft: "3rem" }}
            >
              {currentStep === steps.length - 1 ? "Preview and Send" : "Save and Next"}
            </button>
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default SendReportFar;
